import { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Switch from './components/Switch';
import GenevEventTab from './tabs/GenevEventTab';
import ZurichEventTab from './tabs/ZurichEventTab';
import LuganoEventTab from './tabs/LuganoEventTab';
import LuxEventTab from './tabs/LuxEventTab';

type TabGenerator = () => React.JSX.Element;
interface Tab {
  tabName: string;          // Name of the tab (displayed in the switch component)
  mapUrl: string;
  tabTitle?: string;        // Header title of the tab, if undefined, the tabName will be used
  registerUrl?: string;     // URL to register to the event (for the register button in the header), if undefined, the button will not be displayed
  generator: TabGenerator;  // Function that generates the tab content
}

function App() {
  // Declare tabs here
  //  key: tab name (will be displayed in the switch component)
  //  value: tab generator function (= a function that returns a JSX element)
  const tabs: Record<string, Tab> = {
    'Geneva event': {
      tabName: 'Geneva event',
      tabTitle: "Genev’Hack",
      mapUrl: "./palexpo-plan.pdf",
      registerUrl: "https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594583/",
      generator: GenevEventTab,
    },
    'Zurich event': {
      tabName: 'Zurich\' event',
      tabTitle: "Limmat’Hack",
      mapUrl: "./limmathack-map.png",
      registerUrl: "https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594592/",
      generator: ZurichEventTab,
    },
    'Lugano event': {
      tabName: 'Lugano\' event',
      tabTitle: "Lugano’Hack",
      mapUrl: "./limmathack-map.png",
      registerUrl: "https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594595/",
      generator: LuganoEventTab,
    },
    'Luxembourg event': {
      tabName: 'Luxembourg\' event',
      tabTitle: "Lux’Hack",
      mapUrl: "./limmathack-map.png",
      registerUrl: "https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594598/",
      generator: LuxEventTab,
    },
  };

  /**
   * Quick and dirty solution for selectiing the right tab depending on the url.
   */
  let locationIndex = "Geneva event";
  let selectedIndex = 0; 
  const currentUrl = window.location.href;
  if (currentUrl.includes("genevhack.ch")) {
    locationIndex = "Geneva event";
  } else if (currentUrl.includes("limmathack.ch")) {
    locationIndex = "Zurich event";
    selectedIndex = 1;
  } else if (currentUrl.includes("hackmajor.ch")) {
    locationIndex = "Lugano event";
    selectedIndex = 2;
  } else if (currentUrl.includes("luxhack.lu")) {
    locationIndex = "Luxembourg event";
    selectedIndex = 3;
  } /*else if(currentUrl.includes("localhost")) {
    console.log("dev");
    locationIndex = "Geneva event";
  }*/

  const [selectedTab, setSelectedTab] = useState(locationIndex);
  
  return (
    <>
      <Header
        title={tabs[selectedTab].tabTitle ?? tabs[selectedTab].tabName}
        registerUrl={tabs[selectedTab].registerUrl}
      />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className='switch-container'>
          <Switch
            selectedIndex={selectedIndex}
            choices={Object.keys(tabs)}
            onSelect={(index) => setSelectedTab(Object.keys(tabs)[index])}
          />
        </div>
      </div>
      <main>
        {tabs[selectedTab].generator()}
      </main>
    </>
  );
}

export default App;
